"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NamespacedDataSet_1 = require("./NamespacedDataSet");
/**
 * @internal
 */
class DependencyTracker {
    constructor() {
        this.dependenciesFrom = new NamespacedDataSet_1.default();
        this.dependenciesTo = new NamespacedDataSet_1.default();
    }
    updateDependenciesFrom(namespace, key, newDependencySet) {
        const oldDependencySet = this.dependenciesFrom.get(namespace, key);
        oldDependencySet === null || oldDependencySet === void 0 ? void 0 : oldDependencySet.enumerate((depNs, depKey) => {
            const depsToThisDep = this.dependenciesTo.get(depNs, depKey);
            depsToThisDep === null || depsToThisDep === void 0 ? void 0 : depsToThisDep.remove(namespace, key);
        });
        this.dependenciesFrom.set(namespace, key, newDependencySet);
        newDependencySet === null || newDependencySet === void 0 ? void 0 : newDependencySet.enumerate((depNs, depKey) => {
            let depsToThisDep = this.dependenciesTo.get(depNs, depKey);
            if (!depsToThisDep) {
                depsToThisDep = new NamespacedDataSet_1.default();
                this.dependenciesTo.set(depNs, depKey, depsToThisDep);
            }
            depsToThisDep.set(namespace, key, true);
        });
    }
    updateModifiedItems(inDependencySet, modifiedNamespace, modifiedKey) {
        if (!inDependencySet.get(modifiedNamespace, modifiedKey)) {
            inDependencySet.set(modifiedNamespace, modifiedKey, true);
            const affectedItems = this.dependenciesTo.get(modifiedNamespace, modifiedKey);
            affectedItems === null || affectedItems === void 0 ? void 0 : affectedItems.enumerate((namespace, key) => {
                this.updateModifiedItems(inDependencySet, namespace, key);
            });
        }
    }
    reset() {
        this.dependenciesFrom.removeAll();
        this.dependenciesTo.removeAll();
    }
}
exports.default = DependencyTracker;
//# sourceMappingURL=DependencyTracker.js.map